import { channels } from './channels';
import { fileUpload } from './file-upload';
import * as idEndpoints from './id';
import { id, root } from './social-media';

export const socialMedia = {
  ...root,
  channels,
  fileUpload,
  id: {
    ...id,
    ...idEndpoints,
  },
};
